import { StandalonePage } from "@product-pages/common/types";
import { StandalonePagePath } from "./standalone-page-path";
import { ErrorPage } from "./ErrorPage";
import { LoadingPage } from "./LoadingPage";
import ErrorOptionPage from "./ErrorOptionPage";

export const DEFAULT_STANDALONE_PAGES: StandalonePage[] = [
  {
    path: StandalonePagePath.error,
    component: ErrorPage,
  },
  {
    path: StandalonePagePath.errorOption,
    component: ErrorOptionPage,
  },
  {
    path: StandalonePagePath.loading,
    component: LoadingPage,
  }
];
